import {DataCache} from "./datacache.mjs";
import {request} from "@mecatran/utils";



export class DataLoader{
    constructor(dataLoaderOptions){
        var dataLoaderOptions = dataLoaderOptions || {};
        var _dataCache;
        var _url; 
    
        Object.defineProperty(this,'dataCache',{
            set: function(d){ _dataCache = d },
            get : function(){ return _dataCache }
        });

        Object.defineProperty(this,'url',{
            set : function(u){ _url = u },
            get : function(){ return _url }
        })

        this.initDataLoader(dataLoaderOptions)
    }


    // ==========
    // private 
    // ----------

    setDataCache(c){ this.dataCache = c }
    getDataCache(){ return this.dataCache }

    setUrl(u){ this.url = u };
    getUrl(){ return this.url }

    hasCache(){ return (this.getDataCache() !== undefined) }


    initDataLoader(dataLoaderOptions){
        var cache = ('cache' in dataLoaderOptions) ? dataLoaderOptions.cache : true;
        var url = dataLoaderOptions.url || undefined;
        if (cache) this.setDataCache(new DataCache());
        if (url) this.setUrl(dataLoaderOptions.url);
        
    }

    // ==========
    // overload
    // ----------
    /**
     * should return a promise
     */
    load(){
        var url = this.getUrl();
        if (url){
            var headers =  { 'Accept': 'application/json' }
            var promise = new Promise((resolve,reject)=>{
                var callback = (e,d)=>{
                    if (e) reject(e);
                    resolve(d.body);
                }
                request({url,headers},callback);
            });
            return promise;
        } else throw new Error('DataSource::DataLoader. no url provided')
    }  
    

    // ==========
    // public 
    // ----------
    get(){
        if (this.hasCache()){
            var dataCache = this.getDataCache();
            if (dataCache.isEmpty()) 
                return this.load()
                            .then(dataCache.save.bind(dataCache))
                            .then(dataCache.getData.bind(dataCache))
            else return dataCache.getData();
        }
        else return this.load();
    }

    clearCache(){ 
        var dataCache = this.getDataCache();
        if (dataCache) dataCache.clear();
    }

    /* 17-05 */
    setDataUrl(u){   /* TMP */
        this.setUrl(u);
    }
    

}


export class DataLoaderOptions{
    constructor(options){
        var _cache = (options && options.cache ) ? options.cache : false;
        var _url = (options && options.url ) ? options.url : undefined; 

        Object.defineProperty(this,'cache',{
            get : function(){ return _cache }
        }); 

        Object.defineProperty(this,'url',{
            get : function(){ return _url }
        });
    }
}

